import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../Auth';

function PrivateRoute() {
  const { isAuthenticated } = useAuth();
  if (isAuthenticated !== null) {
    return isAuthenticated ? <Outlet /> : <Navigate to='/login' />;
  }
}

export default PrivateRoute;